import { useEffect, useRef } from 'react';
import { useRoutesContext } from 'common/context/routes';
import { useMapContext } from '../context';
import { polylineFactory, HerePolyline, GooglePolyline } from 'entities/map';

export const useShowTollPolyline = () => {
  const { map } = useMapContext();
  const { activeRoute } = useRoutesContext();
  const activeRoutePolylinesRef = useRef<(HerePolyline | GooglePolyline)[] | undefined>();

  useEffect(() => {
    if (activeRoutePolylinesRef.current) {
      activeRoutePolylinesRef.current.forEach((activeRoutePolyline) => {
        activeRoutePolyline.delete();
      });
    }

    activeRoutePolylinesRef.current = activeRoute?.tolls.reduce(
      (acc, { tollSections }) => {
        if (map && tollSections.length >= 1) {
          tollSections.forEach(({ coordinates }) => {
            if (coordinates.length < 2) {
              console.warn('Polyline requires at least two points. Skipping creation.', coordinates);
              return;
            }
            const polyline = polylineFactory(map, {
              path: coordinates,
              geodesic: true,
              strokeColor: '#2164CF',
              strokeOpacity: 1.0,
              zIndex: 0,
              clickable: false,
            });

            acc.push(polyline);
          });
        }
        return acc;
      },
      [] as (HerePolyline | GooglePolyline)[]
    );
  }, [activeRoute, map]);
};
